import React from 'react';
import { useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import {
  Container,
  StepsContainer,
  StepRow,
  Circle,
  CircleNumber,
  StepTitle,
  StepDuration,
  Separator,
} from './VerticalListStep.styles';

import { ONBOARDING_STEPS } from '@/utils/constants';

type VerticalListStepProps = {
  currentStep: number;
  style?: React.CSSProperties;
};

const VerticalListStep: React.FC<VerticalListStepProps> = ({ currentStep, style }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const primaryColor = theme.palette.secondary.main;
  const inactiveColor = theme.palette.grey[200];

  return (
    <Container style={{ backgroundColor: theme.palette.grey[300], ...style }}>
      <StepsContainer>
        {ONBOARDING_STEPS.map((step, index) => (
          <React.Fragment key={step.titleKey}>
            <StepRow style={{ opacity: index + 1 === currentStep ? 1 : 0.5 }}>
              <Circle style={{ backgroundColor: primaryColor }}>
                <CircleNumber style={{ color: theme.palette.secondary.contrastText }}>
                  {index + 1}
                </CircleNumber>
              </Circle>
              <StepTitle style={{ color: primaryColor }}>{t(step.titleKey)}</StepTitle>
              <StepDuration style={{ color: primaryColor }}>{t(step.durationKey)}</StepDuration>
            </StepRow>
            {index < ONBOARDING_STEPS.length - 1 && (
              <Separator style={{ backgroundColor: inactiveColor }} />
            )}
          </React.Fragment>
        ))}
      </StepsContainer>
    </Container>
  );
};

export default VerticalListStep;
